<template>
    <div class="writeCardApply table-hook fadeInRight">
        <div class="title-box">
            <span class="m-title">空中写号申请记录</span>
            <el-form
                inline
                class="hook right themed-form search-form"
                v-model="form"
                style="line-height: 40px"
            >
                <el-form-item label="EID:">
                    <el-input
                        v-model="form.eid"
                        placeholder="请输入EID"
                    ></el-input>
                </el-form-item>
                <el-form-item label="新ICCID:">
                    <el-input
                        v-model="form.newIccid"
                        placeholder="请输入新ICCID"
                    ></el-input>
                </el-form-item>
                <el-form-item label="新接入号:">
                    <el-input
                        v-model="form.newMsisdn"
                        placeholder="请输入新接入号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="旧ICCID:">
                    <el-input
                        v-model="form.oldIccid"
                        placeholder="请输入旧ICCID"
                    ></el-input>
                </el-form-item>
                <el-form-item label="旧接入号:">
                    <el-input
                        v-model="form.oldMsisdn"
                        placeholder="请输入旧接入号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="申请编号:">
                    <el-input
                        v-model="form.applyNo"
                        placeholder="请输入申请编号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="省份:">
                    <el-select v-model="form.province" placeholder="请选择...">
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-for="(label, value) in provinceMap"
                            :key="value"
                            :label="label"
                            :value="label"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="写号状态:">
                    <el-select
                        v-model="form.status"
                        placeholder="请选择写号状态"
                    >
                        <el-option label="全部" value=""></el-option>
                        <el-option label="写号中" value="0"></el-option>
                        <el-option label="已写号" value="1"></el-option>
                        <el-option label="写号失败" value="2"></el-option>
                        <el-option label="已取消" value="3"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="开始时间:">
                    <el-date-picker
                        type="datetime"
                        placeholder="请选择日期时间"
                        v-model="form.startTime"
                        style="width: 100%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间:">
                    <el-date-picker
                        type="datetime"
                        placeholder="请选择日期时间"
                        v-model="form.endTime"
                        style="width: 100%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="themed-button"
                        @click="searchData"
                        >搜索查询</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-back"
                        class="themed-button"
                        @click="exportExcel"
                        >批量导出</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="themed-button"
                        @click="openBatchUpdateDialog"
                        >批量更新状态</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-close"
                        class="themed-button"
                        @click="openBatchCancelDialog"
                        >批量取消写号</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-plus"
                        class="themed-button"
                        @click="importData"
                        >导入</el-button
                    >
                </el-form-item>
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
            >
                <el-table-column
                    label="EID"
                    prop="eid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="旧ICCID"
                    prop="oldIccid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="旧接入号"
                    prop="oldMsisdn"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="新ICCID"
                    prop="newIccid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="新接入号"
                    prop="newMsisdn"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="申请编号"
                    prop="applyNo"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="写号状态"
                    prop="status"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ formatStatus(scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="省份"
                    prop="province"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="操作人"
                    prop="operatorName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="创建时间"
                    prop="createTime"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="" width="180" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.status === 0"
                            type="primary"
                            class="themed-button"
                            size="mini"
                            :loading="
                                loadingStatus[scope.row.applyNo + '_cancel']
                            "
                            :disabled="
                                disabledStatus[scope.row.applyNo + '_cancel']
                            "
                            @click="handleCancel(scope.row)"
                        >
                            取消写号
                        </el-button>
                        <el-button
                            v-if="scope.row.status !== 3"
                            type="primary"
                            class="themed-button"
                            size="mini"
                            :loading="
                                loadingStatus[scope.row.applyNo + '_update']
                            "
                            :disabled="
                                disabledStatus[scope.row.applyNo + '_update']
                            "
                            @click="handleUpdateStatus(scope.row)"
                        >
                            更新状态
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 50, 100, 1000]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>

        <!-- 导入弹框 -->
        <el-dialog
            title="批量导入"
            :visible.sync="importDialogVisible"
            width="600px"
        >
            <el-form
                label-position="right"
                label-width="180px"
                style="max-height: 500px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:" required>
                    <input class="file-input" type="file" ref="importFile" />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="设备卡信息:">
                    <el-input
                        v-model="importInfo"
                        type="textarea"
                        rows="6"
                        placeholder="请输入ICCID 接入号 省份，每行一组，用空格分开"
                    ></el-input>
                    <div style="color: #f00">
                        请输入ICCID 接入号 省份，每行一组，用空格分开
                    </div>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitImport"
                    >导入excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="importDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量更新状态弹框 -->
        <el-dialog
            title="批量更新状态"
            :visible.sync="batchUpdateDialogVisible"
            width="600px"
        >
            <el-form
                label-position="right"
                label-width="180px"
                style="max-height: 500px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:">
                    <input
                        class="file-input"
                        type="file"
                        ref="batchUpdateFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="申请编号:">
                    <el-input
                        v-model="batchUpdateApplyNos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入申请编号，每行一个"
                    ></el-input>
                    <div style="color: #f00">请输入申请编号，每行一个</div>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchUpdate"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportBatchUpdateTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="batchUpdateDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量取消写号弹框 -->
        <el-dialog
            title="批量取消写号"
            :visible.sync="batchCancelDialogVisible"
            width="600px"
        >
            <el-form
                label-position="right"
                label-width="180px"
                style="max-height: 500px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:">
                    <input
                        class="file-input"
                        type="file"
                        ref="batchCancelFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="申请编号:">
                    <el-input
                        v-model="batchCancelApplyNos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入申请编号，每行一个"
                    ></el-input>
                    <div style="color: #f00">请输入申请编号，每行一个</div>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchCancel"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportBatchCancelTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="batchCancelDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    listWriteCardApply,
    exportWriteCardApply,
    batchImportWriteCardApply,
    cancelWriteCardApply,
    queryAndUpdateWriteCardStatusByServer,
    batchUpdateWriteCardStatus,
    batchCancelWriteCardApply,
} from "@/api/writeCardManagement/writeCardApply.js";
import { messageBox } from "@/utils/common.js";
import resize from "@/mixins/resize.js";
import Utils from "@/utils/utils.js";
import { exportTemplate } from "@/api/statistics.js";

export default {
    name: "writeCardApply",
    mixins: [resize],
    data() {
        return {
            form: {
                eid: "",
                newIccid: "",
                newMsisdn: "",
                oldIccid: "",
                oldMsisdn: "",
                applyNo: "",
                status: "",
                province: "",
                startTime: "",
                endTime: "",
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 导入弹框数据
            importDialogVisible: false,
            importInfo: "",

            // 批量更新状态弹框数据
            batchUpdateDialogVisible: false,
            batchUpdateApplyNos: "", // 申请编号文本

            // 批量取消写号弹框数据
            batchCancelDialogVisible: false,
            batchCancelApplyNos: "", // 申请编号文本

            // 按钮loading状态
            loadingStatus: {}, // 存储每行的loading状态
            // 按钮禁用状态
            disabledStatus: {}, // 存储每行的禁用状态

            // 省份映射数据
            provinceMap: {
                北京市: "北京市",
                天津市: "天津市",
                河北省: "河北省",
                山西省: "山西省",
                内蒙古自治区: "内蒙古自治区",
                辽宁省: "辽宁省",
                吉林省: "吉林省",
                黑龙江省: "黑龙江省",
                上海市: "上海市",
                江苏省: "江苏省",
                浙江省: "浙江省",
                安徽省: "安徽省",
                福建省: "福建省",
                江西省: "江西省",
                山东省: "山东省",
                河南省: "河南省",
                湖北省: "湖北省",
                湖南省: "湖南省",
                广东省: "广东省",
                广西壮族自治区: "广西壮族自治区",
                海南省: "海南省",
                重庆市: "重庆市",
                四川省: "四川省",
                贵州省: "贵州省",
                云南省: "云南省",
                西藏自治区: "西藏自治区",
                陕西省: "陕西省",
                甘肃省: "甘肃省",
                青海省: "青海省",
                宁夏回族自治区: "宁夏回族自治区",
                新疆维吾尔自治区: "新疆维吾尔自治区",
                台湾省: "台湾省",
                香港特别行政区: "香港特别行政区",
                澳门特别行政区: "澳门特别行政区",
                全国: "全国",
            },
        };
    },
    mounted() {
        this.getList();
    },
    activated() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form,
            };

            listWriteCardApply(params).then((res) => {
                if (res && res.page) {
                    this.tableData = res.page.rows || [];
                    this.total = res.page.total || 0;
                }
            });
        },

        // 搜索
        searchData() {
            this.currentPage = 1;
            this.getList();
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },

        // 导出
        exportExcel() {
            exportWriteCardApply(this.form).then((res) => {
                if (res.system_result_key == "0") {
                    this.$alert("导出成功，请到导出记录中下载", "提示", {
                        confirmButtonText: "确定",
                    }).then(() => {
                        this.$router.push("/tob/i_export_list");
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 导入操作
        importData() {
            this.importDialogVisible = true;
        },

        // 提交导入
        submitImport() {
            let file = this.$refs["importFile"].files[0];
            let formData = new FormData();

            // 处理写号信息
            if (!file && !this.importInfo.trim()) {
                messageBox(this, "请选择文件或输入写号信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 无论是否有文件，都添加写号信息到表单
            formData.append("phones", this.importInfo);

            // 二次确认提示
            this.$confirm(
                "写号申请成功后会更新旧卡号信息为新卡号信息，确认要继续导入吗？",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    batchImportWriteCardApply(formData).then((res) => {
                        if (res.system_result_key == "0") {
                            if (file) {
                                this.$alert(
                                    res.system_result_message_key ||
                                        "导入成功，请到导入记录中下载",
                                    "提示",
                                    {
                                        confirmButtonText: "确定",
                                    }
                                ).then(() => {
                                    this.$refs["importFile"].value = "";
                                    this.importInfo = "";
                                    this.importDialogVisible = false;
                                    this.$router.push("/tob/i_import_list");
                                });
                            } else {
                                this.$message.success(
                                    res.system_result_message_key || "导入成功"
                                );
                                this.importInfo = "";
                                this.importDialogVisible = false;
                                this.getList();
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.system_result_message_key,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消导入操作",
                    });
                });
        },

        // 导出模板
        exportTemplate() {
            exportTemplate({ name: "importWriteCardApply.xls" }).then((res) => {
                const filename = "importWriteCardApply.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return "-";

            try {
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error("日期格式化错误:", error);
                return dateTime;
            }
        },

        // 格式化状态
        formatStatus(status) {
            const statusMap = {
                0: "写号中",
                1: "已写号",
                2: "写号失败",
                3: "已取消",
            };
            return statusMap[status] || "-";
        },

        // 取消写号操作
        handleCancel(row) {
            // 设置按钮禁用状态
            this.$set(this.disabledStatus, row.applyNo + "_cancel", true);
            this.$set(this.loadingStatus, row.applyNo + "_cancel", true);

            this.$confirm(
                "取消申请写号成功，新卡号信息将会恢复成旧卡号信息，确认要取消该写号操作吗？",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    cancelWriteCardApply({
                        applyNo: row.applyNo,
                    })
                        .then((res) => {
                            if (res.system_result_key === "0") {
                                this.$message({
                                    type: "success",
                                    message:
                                        res.system_result_message_key ||
                                        "取消成功",
                                });
                                this.getList(); // 刷新列表
                            } else {
                                this.$message({
                                    type: "error",
                                    message:
                                        res.system_result_message_key ||
                                        "取消失败",
                                });
                            }
                        })
                        .finally(() => {
                            this.$set(
                                this.loadingStatus,
                                row.applyNo + "_cancel",
                                false
                            );
                            // 10秒后恢复按钮可用状态
                            setTimeout(() => {
                                this.$set(
                                    this.disabledStatus,
                                    row.applyNo + "_cancel",
                                    false
                                );
                            }, 10000);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                    // 用户取消也要清除loading状态，但保持禁用状态10秒
                    this.$set(
                        this.loadingStatus,
                        row.applyNo + "_cancel",
                        false
                    );
                    // 10秒后恢复按钮可用状态
                    setTimeout(() => {
                        this.$set(
                            this.disabledStatus,
                            row.applyNo + "_cancel",
                            false
                        );
                    }, 10000);
                });
        },

        // 更新写号状态操作
        handleUpdateStatus(row) {
            // 设置按钮禁用状态
            this.$set(this.disabledStatus, row.applyNo + "_update", true);
            this.$set(this.loadingStatus, row.applyNo + "_update", true);

            this.$confirm("确认要更新该记录的写号状态吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    queryAndUpdateWriteCardStatusByServer({
                        applyNo: row.applyNo,
                    })
                        .then((res) => {
                            if (res.system_result_key === "0") {
                                this.$message({
                                    type: "success",
                                    message:
                                        res.system_result_message_key ||
                                        "状态更新成功",
                                });
                                this.getList(); // 刷新列表
                            } else {
                                this.$message({
                                    type: "error",
                                    message:
                                        res.system_result_message_key ||
                                        "状态更新失败",
                                });
                            }
                        })
                        .finally(() => {
                            this.$set(
                                this.loadingStatus,
                                row.applyNo + "_update",
                                false
                            );
                            // 10秒后恢复按钮可用状态
                            setTimeout(() => {
                                this.$set(
                                    this.disabledStatus,
                                    row.applyNo + "_update",
                                    false
                                );
                            }, 10000);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消状态更新",
                    });
                    // 用户取消也要清除loading状态，但保持禁用状态10秒
                    this.$set(
                        this.loadingStatus,
                        row.applyNo + "_update",
                        false
                    );
                    // 10秒后恢复按钮可用状态
                    setTimeout(() => {
                        this.$set(
                            this.disabledStatus,
                            row.applyNo + "_update",
                            false
                        );
                    }, 10000);
                });
        },

        // 打开批量更新状态对话框
        openBatchUpdateDialog() {
            this.batchUpdateDialogVisible = true;
            // 清空表单
            this.$nextTick(() => {
                if (this.$refs["batchUpdateFile"]) {
                    this.$refs["batchUpdateFile"].value = "";
                }
            });
            this.batchUpdateApplyNos = "";
        },

        // 导出批量更新状态模板
        exportBatchUpdateTemplate() {
            exportTemplate({ name: "importApplyNo.xls" }).then((res) => {
                const filename = "importApplyNo.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 提交批量更新状态
        submitBatchUpdate() {
            let file = this.$refs["batchUpdateFile"].files[0];
            let formData = new FormData();

            // 处理申请编号信息
            if (!file && !this.batchUpdateApplyNos.trim()) {
                messageBox(this, "请选择文件或输入申请编号");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 无论是否有文件，都添加申请编号到表单
            if (this.batchUpdateApplyNos.trim()) {
                formData.append("applyNos", this.batchUpdateApplyNos.trim());
            }

            // 二次确认提示
            this.$confirm("确认要批量更新写号状态吗？", "批量更新状态", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    batchUpdateWriteCardStatus(formData)
                        .then((res) => {
                            if (res.system_result_key == "0") {
                                // 解析返回消息，提取失败数量
                                const message =
                                    res.system_result_message_key ||
                                    "批量更新完成";
                                this.$alert(message, "提示", {
                                    confirmButtonText: "确定",
                                }).then(() => {
                                    // 清空表单
                                    if (this.$refs["batchUpdateFile"]) {
                                        this.$refs["batchUpdateFile"].value =
                                            "";
                                    }
                                    this.batchUpdateApplyNos = "";
                                    this.batchUpdateDialogVisible = false;
                                    this.getList(); // 刷新列表
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.system_result_message_key,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            console.error("批量更新失败:", error);
                            this.$message({
                                showClose: true,
                                message: "批量更新失败，请重试",
                                type: "error",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消批量更新操作",
                        });
                });
        },

        // 打开批量取消写号对话框
        openBatchCancelDialog() {
            this.batchCancelDialogVisible = true;
            // 清空表单
            this.$nextTick(() => {
                if (this.$refs["batchCancelFile"]) {
                    this.$refs["batchCancelFile"].value = "";
                }
            });
            this.batchCancelApplyNos = "";
        },

        // 导出批量取消写号模板
        exportBatchCancelTemplate() {
            exportTemplate({ name: "importApplyNo.xls" }).then((res) => {
                const filename = "importApplyNo.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 提交批量取消写号
        submitBatchCancel() {
            let file = this.$refs["batchCancelFile"].files[0];
            let formData = new FormData();

            // 处理申请编号信息
            if (!file && !this.batchCancelApplyNos.trim()) {
                messageBox(this, "请选择文件或输入申请编号");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 无论是否有文件，都添加申请编号到表单
            if (this.batchCancelApplyNos.trim()) {
                formData.append("applyNos", this.batchCancelApplyNos.trim());
            }

            // 二次确认提示
            this.$confirm("确认要批量取消写号吗？", "批量取消写号", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    batchCancelWriteCardApply(formData)
                        .then((res) => {
                            if (res.system_result_key == "0") {
                                const message =
                                    res.system_result_message_key ||
                                    "批量取消完成";
                                this.$alert(message, "提示", {
                                    confirmButtonText: "确定",
                                }).then(() => {
                                    // 清空表单
                                    if (this.$refs["batchCancelFile"]) {
                                        this.$refs["batchCancelFile"].value =
                                            "";
                                    }
                                    this.batchCancelApplyNos = "";
                                    this.batchCancelDialogVisible = false;
                                    this.getList(); // 刷新列表
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.system_result_message_key,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            console.error("批量取消失败:", error);
                            this.$message({
                                showClose: true,
                                message: "批量取消失败，请重试",
                                type: "error",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消批量取消操作",
                    });
                });
        },
    },
};
</script>

<style scoped>
::v-deep .el-table .cell {
    padding: 0;
}
.writeCardApply {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}
</style> 